/** @file readHistory: where undo and redo stand (`revisions` `history`) read into `puppet.history`. */
import type { ServerContext } from './serverContext';

/** Reads the newest revision's history step; a failed read leaves it unknown (null); a stale `token` writes nothing. */
export async function readHistory(ctx: ServerContext, id: string, token: number): Promise<void> {
  try {
    const reply = await ctx.api.puppets.revisions(id, { from: ctx.get().puppet.revision, limit: 1 });
    if (token === ctx.token) ctx.set((s) => ({ puppet: { ...s.puppet, history: reply.history ?? null } }));
  } catch {
    if (token === ctx.token) ctx.set((s) => ({ puppet: { ...s.puppet, history: null } }));
  }
}
